import { render, staticRenderFns } from "./OpportunityNotificationsTrigger.vue?vue&type=template&id=d3948f56"
import script from "./OpportunityNotificationsTrigger.vue?vue&type=script&lang=ts"
export * from "./OpportunityNotificationsTrigger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports